import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { msalLogin } from '$/store/msal/actions';
import BixButton from '$/components/global/bixButton';
import './index.scss';

export interface IMsalAuthenticationRequiredProps {
  dispatchOnMsalLogin?: () => Promise<void>;
  isMsalAuthenticated: boolean;
  children?: React.ReactNode;
}

const MsalAuthenticationRequired: React.FC<IMsalAuthenticationRequiredProps> = props => {
  const { dispatchOnMsalLogin, isMsalAuthenticated } = props;

  if (!isMsalAuthenticated) {
    return (
      <div className="authentication_required_container">
        <div className="message">
          <p>Authentication Required.</p>
          <BixButton useSmall onClick={dispatchOnMsalLogin}>
            Login to Microsoft
          </BixButton>
        </div>
      </div>
    );
  } else {
    return <React.Fragment>{props.children}</React.Fragment>;
  }
};

const mapStateToProps = (state: AppState) => {
  return {
    isMsalAuthenticated: state.msalState.authenticated,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchOnMsalLogin: () => dispatch(msalLogin()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MsalAuthenticationRequired);
